import { useLocation } from 'react-router'
import { ConsignmentClusteringLoadingSkeleton } from '~/pages/consignment-clustering/@x/consignment-page'

export function LoadingSkeleton() {
  const location = useLocation()

  switch (location.pathname.split('/').at(-1)) {
    case 'clustering':
      return <ConsignmentClusteringLoadingSkeleton />
    default:
      return null
  }
}
